import { isBefore, parseISO, startOfDay } from "date-fns";

import type { ShipmentManagement } from "~/shared/schemas/shipment-management-schema.ts";

type ExpirableShipment = {
	carrier?: Pick<ShipmentManagement["carrier"], "expDate"> | null;
	shipmentDetails?: {
		pickup?: Pick<ShipmentManagement["shipmentDetails"]["pickup"], "actual">;
	} | null;
};

// parseISO keeps date-only values in local time; fall back for non-ISO formats (e.g. MM/dd/yyyy).
const parseExpirationDate = (value: string): Date | null => {
	const iso = parseISO(value);
	const parsed = Number.isNaN(iso.getTime()) ? new Date(value) : iso;
	if (Number.isNaN(parsed.getTime()) || parsed.getFullYear() <= 1900) {
		return null;
	}
	return parsed;
};

/**
 * True when the carrier quote expired before today and the shipment has not
 * been picked up yet, so it must be rerated before it can be API dispatched.
 */
export const isQuoteExpired = (
	shipment: ExpirableShipment | null | undefined,
	today: Date = new Date(),
): boolean => {
	const expDate = shipment?.carrier?.expDate;
	if (!expDate || shipment?.shipmentDetails?.pickup?.actual) {
		return false;
	}
	const expiration = parseExpirationDate(expDate);
	return expiration !== null && isBefore(expiration, startOfDay(today));
};
